// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'
const serveName = process.env.VUE_APP_SERVENAME

// 获取系统消息列表
export const postListInformationNotice = (data: any) =>
  request(`/${serveName}/information/listInformationNotice`, null, 'POST_JSON', data)

// 获取系统消息单条
export const postItemInformationNotice = (data: { id: number }) =>
  request(`/${serveName}/information/selectById`, null, 'POST_JSON', data)

// 新增系统消息
export const postAddInformationNotice = (data: any) =>
  request(`/${serveName}/information/addInformationNotice`, null, 'POST_JSON', data)

// 删除系统消息
export const postDeleteInformationNotice = (data: { noticeIds: string }) =>
  request(`/${serveName}/information/deleteInformationNotice`, null, 'POST_JSON', data)

// 撤回系统消息
export const postGetBackInformationNotice = (data: { id: string; sendStatus: number }) =>
  request(`/${serveName}/information/getBackInformationNotice`, null, 'POST_JSON', data)

// 查询用户的系统消息(2025-6-12配合后端漏洞修复接口不要入参)
export const postListUserNotice = () =>
  request(`/${serveName}/information/listUserNotice`, null, 'POST_JSON', null)

// 更新系统消息
export const postUpdateInformationNotice = (data: any) =>
  request(`/${serveName}/information/updateInformationNotice`, null, 'POST_JSON', data)

// 更新系统消息已读状态
export const postUpdateUserReadNoticeStatus = (data: { noticeIds: string }) =>
  request(`/${serveName}/information/updateUserReadNoticeStatus`, null, 'POST_JSON', data)

//查看所有系统消息list
export const postSelectAllUserNotice = (data: { title?: string }) =>
  request(`/${serveName}/information/selectAllUserNotice`, null, 'POST_JSON', data)
